import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { setCoopAltreCoopSpecificListeners } from './coop-altre-coop-specific.listeners';

export class CoopAltreCoopFormListeners extends FormListeners {
    constructor(form: FormGroup, private readonly store: Store<Revisione53State>) {
        super(form);
    }

    setListeners(): void {
        setCoopAltreCoopSpecificListeners(this.form, this.store);
    }
}
